export class CstCustPIIEntityIdDto {
    doctype:string;
    portfolioId:number;
    custId:string;
    // occupationTypcode:string;    
}